
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 11.927s.677.194.774-1.113h.05v-.145s.192-.387.192-.532V5.635s0-.242-.242-.387c0-.339.05-.823-.049-1.016C8.08 3.99 8.13 3.41 7.5 3.41c-.63 0-.58.63-.726.823-.097.193-.049.677-.049 1.016-.242.145-.242.387-.242.387v4.502c0 .145.194.532.194.532v.145h.048c.145 1.258.775 1.113.775 1.113z"}}),_c('path',{attrs:{"d":"M7.674 4.261l.375.417 1.958 2.75-.25.167s-.042 0-.083-.042c-.042-.042-1.75-2.458-1.75-2.458l-.042-.459-.25-.375h-.125c-.125 0-.25-.125-.292-.25l-.583.167-3.376.333v-.333s0-.042.084-.042c.083 0 3-.292 3-.292l.417.21.458-.043c.042-.125.125-.208.292-.208.042 0 .083 0 .125.041l.208-.5L9.299.261l.29.125s.043.041 0 .125c-.04.083-1.25 2.75-1.25 2.75l-.374.25-.208.417a.315.315 0 01.083.208c-.083 0-.125.083-.166.125zM7.857 11.023l.55-.042 3.433.127v.297s0 .042-.085.042c-.084 0-3.05-.084-3.05-.084l-.383-.255-.465-.042c0 .042-.043.085-.043.085-.085.127-.254.127-.382.084l-.296.551-1.823 2.925-.254-.17s-.042-.042 0-.127c.042-.085 1.611-2.586 1.611-2.586l.381-.21.254-.383c-.085-.084-.085-.254 0-.339l.085-.085-.254-.466-1.61-3.094.254-.127s.042 0 .084.085c.043.085 1.441 2.712 1.441 2.712l-.042.467.212.423c.085 0 .17 0 .212.043.127.042.17.084.17.17z"}})])
          )
        }
      }
    